module.exports = __webpack_public_path__ + "img/bulb.ac87a182.svg";